export default "__VITE_PUBLIC_ASSET__b3f0f56e__"